import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Users, Mail, Phone, MapPin } from 'lucide-react';

const PRODUCT_TYPES = {
  honey: { label: 'Honey', icon: '🍯' },
  nuc: { label: 'Nuc', icon: '📦' },
  queen: { label: 'Queen', icon: '👑' },
  bee_package: { label: 'Bee Package', icon: '🐝' },
  hive: { label: 'Hive', icon: '🏠' },
  equipment: { label: 'Equipment', icon: '🔧' },
};

const CustomerDetailDialog = ({ customer, onClose, formatDate }) => (
  <Dialog open={!!customer} onOpenChange={() => onClose()}>
    <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          {customer?.name}
        </DialogTitle>
      </DialogHeader>
      {customer && (
        <div className="space-y-4">
          <div className="bg-blue-50 rounded-lg p-4 space-y-2">
            {customer.email && (
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 text-blue-500" />
                <a href={`mailto:${customer.email}`} className="text-blue-600 hover:underline">{customer.email}</a>
              </div>
            )}
            {customer.phone && (
              <div className="flex items-center gap-2 text-sm">
                <Phone className="h-4 w-4 text-blue-500" />
                <a href={`tel:${customer.phone}`} className="text-blue-600 hover:underline">{customer.phone}</a>
              </div>
            )}
            {customer.address && (
              <div className="flex items-center gap-2 text-sm">
                <MapPin className="h-4 w-4 text-blue-500" /><span>{customer.address}</span>
              </div>
            )}
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-green-50 rounded-lg p-3 text-center">
              <div className="text-xl font-bold text-green-600">${customer.total_spent?.toFixed(0) || 0}</div>
              <div className="text-xs text-green-500">Total Spent</div>
            </div>
            <div className="bg-stone-50 rounded-lg p-3 text-center">
              <div className="text-xl font-bold text-stone-600">{customer.total_purchases || 0}</div>
              <div className="text-xs text-stone-500">Purchases</div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-stone-700 mb-2">Purchase History</h4>
            {customer.purchase_history?.length > 0 ? (
              <div className="space-y-2 max-h-48 overflow-y-auto">
                {customer.purchase_history.map(sale => {
                  const productConfig = PRODUCT_TYPES[sale.product_type] || PRODUCT_TYPES.equipment;
                  return (
                    <div key={sale.id} className="flex items-center justify-between p-2 bg-stone-50 rounded text-sm">
                      <div className="flex items-center gap-2">
                        <span>{productConfig.icon}</span>
                        <span>{sale.product_name || productConfig.label}</span>
                        <span className="text-stone-400">&times;{sale.quantity}</span>
                      </div>
                      <div className="text-right">
                        <span className="font-medium text-green-600">${sale.total_price?.toFixed(0) || 0}</span>
                        <span className="text-stone-400 text-xs ml-2">{formatDate(sale.date)}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-sm text-stone-400 text-center py-4">No purchase history</p>
            )}
          </div>
          {customer.notes && (
            <div>
              <h4 className="font-medium text-stone-700 mb-1">Notes</h4>
              <p className="text-sm text-stone-500 bg-stone-50 rounded p-2">{customer.notes}</p>
            </div>
          )}
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default CustomerDetailDialog;
